import i18n from 'i18n';
import { ColGroupDef } from '@ag-grid-enterprise/all-modules';
import { Xdp } from 'data/xdp/xdp.types';

export enum XdpMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newXdp: Xdp = {
  id: '',
  inPortEnd: '',
  inPortStart: '',
  insideNat: false,
  ipAddr: '',
  ipduId: '',
  outPortEnd: '',
  outPortStart: '',
  nodeName: '',
  port: '',
  state: '',
  switchTech: '',
};

export const xdpColumnDefs: ColGroupDef[] = [
  {
    headerName: '',
    children: [
      {
        headerName: i18n.t('xdp.grid.xdpId'),
        field: 'ipduId',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('xdp.grid.ipAddress'),
        field: 'ipAddr',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('xdp.grid.port'),
        field: 'port',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
    ],
  },
  {
    headerName: i18n.t('xdp.grid.incomingTrafficRange'),
    children: [
      {
        headerName: i18n.t('xdp.grid.incomingStartingPortNumber'),
        field: 'inPortStart',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('xdp.grid.incomingEndingPortNumber'),
        field: 'inPortEnd',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
    ],
  },
  {
    headerName: i18n.t('xdp.grid.outgoingTrafficRange'),
    children: [
      {
        headerName: i18n.t('xdp.grid.outgoingStartingPortNumber'),
        field: 'outPortStart',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('xdp.grid.outgoingEndingPortNumber'),
        field: 'outPortEnd',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        filterParams: {
          buttons: ['clear', 'apply'],
        },
        resizable: true,
        tooltipField: 'name',
        flex: 1,
        minWidth: 198,
      },
    ],
  },
];
